/**
 * @flow
 * @relayHash a1f01861ed2a22b23261e521cdff9d1f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EpgItem_epgitem$ref = any;
type TopicSelector_viewer$ref = any;
export type queries_EpgItem_QueryVariables = {|
  id: string
|};
export type queries_EpgItem_QueryResponse = {|
  +epgitem: ?{|
    +$fragmentRefs: EpgItem_epgitem$ref
  |},
  +viewer: ?{|
    +tvshows: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +title: ?string,
        |}
      |}>
    |},
    +$fragmentRefs: TopicSelector_viewer$ref,
  |},
|};
export type queries_EpgItem_Query = {|
  variables: queries_EpgItem_QueryVariables,
  response: queries_EpgItem_QueryResponse,
|};
*/


/*
query queries_EpgItem_Query(
  $id: ID!
) {
  epgitem: node(id: $id) {
    __typename
    ...EpgItem_epgitem
    id
  }
  viewer {
    tvshows(first: -1) {
      edges {
        node {
          id
          title
        }
      }
    }
    ...TopicSelector_viewer
    id
  }
}

fragment EpgItem_epgitem on TVShowEpisode {
  id
  title
  subtitle
  description
  shortDescription
  startDate
  endDate
  liveShow
  surdo
  show {
    id
  }
  videoFile {
    id
    filename
  }
  preview {
    id
    filename
  }
  topics {
    id
    name
  }
  state
}

fragment TopicSelector_viewer on Viewer {
  topicsForSelector: topics(first: -1) {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": -1,
    "type": "Int"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "tvshows",
  "storageKey": "tvshows(first:-1)",
  "args": v2,
  "concreteType": "TVShowConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "TVShowEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TVShow",
          "plural": false,
          "selections": [
            v3,
            v4
          ]
        }
      ]
    }
  ]
},
v6 = [
  v3,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "filename",
    "args": null,
    "storageKey": null
  }
],
v7 = [
  v3,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_EpgItem_Query",
  "id": null,
  "text": "query queries_EpgItem_Query(\n  $id: ID!\n) {\n  epgitem: node(id: $id) {\n    __typename\n    ...EpgItem_epgitem\n    id\n  }\n  viewer {\n    tvshows(first: -1) {\n      edges {\n        node {\n          id\n          title\n        }\n      }\n    }\n    ...TopicSelector_viewer\n    id\n  }\n}\n\nfragment EpgItem_epgitem on TVShowEpisode {\n  id\n  title\n  subtitle\n  description\n  shortDescription\n  startDate\n  endDate\n  liveShow\n  surdo\n  show {\n    id\n  }\n  videoFile {\n    id\n    filename\n  }\n  preview {\n    id\n    filename\n  }\n  topics {\n    id\n    name\n  }\n  state\n}\n\nfragment TopicSelector_viewer on Viewer {\n  topicsForSelector: topics(first: -1) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_EpgItem_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "epgitem",
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EpgItem_epgitem",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v5,
          {
            "kind": "FragmentSpread",
            "name": "TopicSelector_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_EpgItem_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "epgitem",
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          },
          v3,
          {
            "kind": "InlineFragment",
            "type": "TVShowEpisode",
            "selections": [
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "subtitle",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shortDescription",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "startDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "liveShow",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "surdo",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "show",
                "storageKey": null,
                "args": null,
                "concreteType": "TVShow",
                "plural": false,
                "selections": [
                  v3
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "videoFile",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": false,
                "selections": v6
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "preview",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": false,
                "selections": v6
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "topics",
                "storageKey": null,
                "args": null,
                "concreteType": "Topic",
                "plural": true,
                "selections": v7
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "state",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v5,
          {
            "kind": "LinkedField",
            "alias": "topicsForSelector",
            "name": "topics",
            "storageKey": "topics(first:-1)",
            "args": v2,
            "concreteType": "TopicConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TopicEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Topic",
                    "plural": false,
                    "selections": v7
                  }
                ]
              }
            ]
          },
          v3
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '42ce85e7bd1c026f7f0c0630ca3634a8';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_EpgItem_Query.graphql.js